import { driver, type DriveStep } from "driver.js";
import "driver.js/dist/driver.css";

/**
 * Thin wrapper over driver.js so we centralise styling + dismissal handling.
 * Resolves once the tour finishes (either via the final step or via close).
 * Both outcomes count as "done" — we don't want to re-show the same tour
 * just because the user clicked the X. Settings → Tours lets them replay.
 */
export function runTour(steps: DriveStep[]): Promise<void> {
  return new Promise((resolve) => {
    // Filter out any steps whose element doesn't exist yet — otherwise
    // driver.js throws when it can't find a selector.
    const present = steps.filter((s) => {
      if (!s.element) return true;
      if (typeof s.element !== "string") return true;
      return !!document.querySelector(s.element);
    });
    if (present.length === 0) {
      resolve();
      return;
    }
    const d = driver({
      animate: true,
      showProgress: true,
      allowClose: true,
      overlayOpacity: 0.65,
      stagePadding: 6,
      stageRadius: 8,
      nextBtnText: "Next →",
      prevBtnText: "← Back",
      doneBtnText: "Got it",
      steps: present,
      onDestroyed: () => resolve(),
    });
    d.drive();
  });
}